const profileTestIDs = {
  profileScreen: 'profile-screen',
  profileRankName: 'profile-rank-name',
  profileFullName: 'profile-full-name',
  profileRankProgress: 'profile-rank-progress',
  profileAccountSettings: 'profile-account-settings',
  profileSecuritySettings: 'profile-security-settings',
  profileLogOut: 'profile-log-out',
  profileFeedback: 'profile-share-feedback',
  profileWhatsNew: 'profile-whats-new',
  profilePrivacyPolicy: 'profile-privacy-policy',
  profileTermsConditions: 'profile-terms-conditions',
  profileAppVersion: 'profile-app-version-value',
  profileOptaviaPay: 'profile-optavia-pay',
  profileSwitchToOptaviaApp: 'profile-switch-to-optavia-app',

  messageUs: 'profile-message-us-view',
  messageUsHeader: 'profile-message-us-header',
  messageUsDescription: 'profile-message-us-description',
  messageUsSecondDescription: 'profile-message-us--second-description',

  profileBusinessSection: 'profileBusinessSection',
  profileManageMySite: 'profileManageMySite',
  profileHealthcareProvider: 'profileHealthcareProvider',
  profileSupportedLanguages: 'profileSupportedLanguages',
  profileLeadsPool: 'profileLeadsPool',
};

export default profileTestIDs;
